(function () {
  const categorySearches = [
    [['new', 'new in', 'new-in', 'new arrivals', 'restocks'], '/collections/new-in'],
    [['kids', 'kid', 'children', 'childrens', "children's", 'boys', 'boy', 'girls', 'girl', 'toddler', 'toddlers', 'youth', 'nino', 'ninos', 'nina', 'ninas'], '/pages/kids-outerwear'],
    [['parka', 'parkas', 'winter coat', 'winter coats', 'winter jacket', 'winter jackets', 'snow coat', 'snow coats'], '/collections/parkas'],
    [['puffer', 'puffers', 'puffer jacket', 'puffer jackets', 'bubble jacket', 'bubble jackets', 'bubble coat', 'bubble coats'], '/collections/puffers'],
    [['statement', 'statement outerwear', 'statement pieces', 'melton', 'embroidered', 'embroidery'], '/collections/statement-outerwear'],
    [['leather', 'faux leather', 'vegan leather', 'pleather', 'faux', 'nubuck'], '/collections/faux-leather'],
    [['varsity', 'varsity jacket', 'varsity jackets'], '/collections/varsity'],
    [['workwear', 'utility', 'utility jacket', 'utility jackets'], '/collections/nexus'],
    [['winter', 'heavy winter', 'cold weather'], '/collections/parkas'],
    [['big tall', 'big and tall', 'big & tall', '2x', '2xl', '3x', '3xl', '4x', '4xl', '5x', '5xl', '6x', '6xl'], '/collections/big-and-tall'],
    [['shop all', 'outerwear', 'jacket', 'jackets'], '/collections/all']
  ];

  const styleSearchTerms = [
    'avalanche',
    'pathfinder',
    'northbound',
    'summit',
    'expedition',
    'aviator',
    'heritage bear',
    'lucky voyager',
    'nexus',
    'kumo',
    'g o a t'
  ];

  function normalizeSearch(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .replace(/\s+/g, ' ');
  }

  function categoryUrlFor(query) {
    const normalized = normalizeSearch(query);

    if (!normalized) return '';

    if (styleSearchTerms.some((term) => normalized.includes(normalizeSearch(term)))) {
      return '';
    }

    for (const [terms, url] of categorySearches) {
      const normalizedTerms = terms.map(normalizeSearch);
      if (normalizedTerms.includes(normalized)) {
        return url;
      }
    }

    return '';
  }

  function ensureProductOnlySearchForms() {
    document.querySelectorAll('form[action*="/search"]').forEach((form) => {
      if (!(form instanceof HTMLFormElement) || form.dataset.awakndlandSearchTidied === 'true') return;

      const typeInput = form.querySelector('input[name="type"]') || document.createElement('input');
      typeInput.type = 'hidden';
      typeInput.name = 'type';
      typeInput.value = 'product';

      if (!typeInput.parentElement) {
        form.appendChild(typeInput);
      }

      const prefixInput = form.querySelector('input[name="options[prefix]"]') || document.createElement('input');
      prefixInput.type = 'hidden';
      prefixInput.name = 'options[prefix]';
      prefixInput.value = 'last';

      if (!prefixInput.parentElement) {
        form.appendChild(prefixInput);
      }

      form.dataset.awakndlandSearchTidied = 'true';
    });
  }

  function handleSearchForm(form, event) {
    if (!form || !(form instanceof HTMLFormElement)) return false;

    const action = form.getAttribute('action') || '';

    if (!action.includes('/search')) return false;

    const searchInput = form.querySelector('input[name="q"]');
    const categoryUrl = categoryUrlFor(searchInput ? searchInput.value : '');

    if (!categoryUrl) return false;

    event.preventDefault();
    event.stopPropagation();
    window.location.assign(categoryUrl);

    return true;
  }

  document.addEventListener(
    'submit',
    function (event) {
      handleSearchForm(event.target, event);
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      const button = event.target && event.target.closest ? event.target.closest('button[type="submit"]') : null;
      const form = button ? button.closest('form[action*="/search"]') : null;

      handleSearchForm(form, event);
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Enter') return;

      const input = event.target && event.target.closest ? event.target.closest('input[name="q"]') : null;
      const form = input ? input.closest('form[action*="/search"]') : null;

      handleSearchForm(form, event);
    },
    true
  );

  function redirectExistingSearchPage() {
    const pathname = window.location.pathname.replace(/\/+$/, '');

    if (pathname === '/collections') {
      window.location.replace('/collections/all');
      return;
    }

    if (pathname !== '/search') return;

    const params = new URLSearchParams(window.location.search);
    const categoryUrl = categoryUrlFor(params.get('q') || '');

    if (categoryUrl) {
      window.location.replace(categoryUrl);
    }
  }

  function tidyVisibleProductTitles() {
    document
      .querySelectorAll(
        '.template-product h1, .awakndland-product-card__title, .card-title, .view-product-title'
      )
      .forEach((node) => {
        if (!node || node.dataset.awakndlandTitleTidied === 'true') return;

        const cleaned = node.textContent.replace(/[“”]/g, '').replace(/\s+/g, ' ').trim();
        if (cleaned && cleaned !== node.textContent.trim()) {
          node.textContent = cleaned;
        }

        node.dataset.awakndlandTitleTidied = 'true';
      });
  }

  function syncSearchRecovery() {
    const recovery = document.querySelector('[data-awakndland-search-recovery]');
    if (!recovery) return;
    const params = new URLSearchParams(window.location.search);
    const hasUrlFilters = Array.from(params).some(([key, value]) => key.startsWith('filter.') && value.trim() !== '');
    const hasFilters = recovery.dataset.activeFilters === 'true' || hasUrlFilters;
    const filtered = recovery.querySelector('[data-search-filtered]');
    const unfiltered = recovery.querySelector('[data-search-unfiltered]');
    if (filtered && unfiltered) {
      filtered.hidden = !hasFilters;
      unfiltered.hidden = hasFilters;
    }
  }

  let searchRecoveryObserver;
  function observeSearchRecovery() {
    if (searchRecoveryObserver) searchRecoveryObserver.disconnect();
    syncSearchRecovery();
    const grid = document.querySelector('.template-search #ProductGridContainer');
    if (!grid) return;
    searchRecoveryObserver = new MutationObserver(syncSearchRecovery);
    searchRecoveryObserver.observe(grid, { childList: true, subtree: true });
  }

  window.addEventListener('popstate', syncSearchRecovery);

  redirectExistingSearchPage();
  ensureProductOnlySearchForms();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      ensureProductOnlySearchForms();
      tidyVisibleProductTitles();
      observeSearchRecovery();
    });
  } else {
    tidyVisibleProductTitles();
    observeSearchRecovery();
  }

  document.addEventListener('shopify:section:load', function () {
    ensureProductOnlySearchForms();
    tidyVisibleProductTitles();
    observeSearchRecovery();
  });
})();

  if (!customElements.get('awakndland-linked-color-swatches')) {
    customElements.define('awakndland-linked-color-swatches', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.compact === 'true') return;
        this.frame = requestAnimationFrame(() => {
          if (!this.isConnected) return;
          this.picker = this.closest('variant-selects, variant-edit-selects, variant-edit-cart-selects');
          this.onChange = () => this.updateLinks(this.selectedSize(this.picker));
          this.picker?.addEventListener('change', this.onChange, true);
          if (this.picker?.tagName === 'VARIANT-SELECTS' && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribe = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
              const picker = data?.event?.target?.closest('variant-selects');
              if (!picker) return;
              if (picker !== this.picker && picker.dataset.productId !== this.dataset.productId) return;
              this.updateLinks(this.selectedSize(picker));
            });
          }
          this.updateLinks(this.selectedSize(this.picker));
        });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.picker?.removeEventListener('change', this.onChange, true);
        this.unsubscribe?.();
        this.unsubscribe = undefined;
      }

      selectedSize(picker) {
        if (!picker || !Number(this.dataset.sizePosition)) return this.dataset.selectedSize;
        const name = this.dataset.sizeOptionName;
        const suffix = `-${this.dataset.productId}-${this.dataset.sizePosition}`;
        const control = Array.from(picker.querySelectorAll('select, input[type="radio"]')).find((input) => {
          const controlName = input.name.trim();
          const isSize = controlName === `options[${name}]` || controlName === name || controlName.endsWith(suffix);
          return isSize && (input.tagName === 'SELECT' || input.checked);
        });
        return control ? control.value : this.dataset.selectedSize;
      }

      displaySize(size) {
        const raw = String(size ?? '');
        const key = raw.trim().toLowerCase().replaceAll('_', '-').replaceAll(' ', '-');
        const aliases = {
          'xxs': 'two_x_small', 'xx-small': 'two_x_small', 'xxsmall': 'two_x_small', '2x-small': 'two_x_small', '2xsmall': 'two_x_small', '2xs': 'two_x_small', '2-xs': 'two_x_small',
          'xs': 'extra_small', 'x-small': 'extra_small', 'xsmall': 'extra_small', 'extra-small': 'extra_small',
          's': 'small', 'small': 'small', 'm': 'medium', 'medium': 'medium', 'l': 'large', 'large': 'large',
          'xl': 'extra_large', 'x-large': 'extra_large', 'xlarge': 'extra_large', 'extra-large': 'extra_large',
          'xx-large': 'two_x_large', 'xxlarge': 'two_x_large', 'xxl': 'two_x_large', '2x-large': 'two_x_large', '2xlarge': 'two_x_large', '2x': 'two_x_large', '2-xl': 'two_x_large', '2xl': 'two_x_large',
          'xxx-large': 'three_x_large', 'xxxlarge': 'three_x_large', 'xxxl': 'three_x_large', '3x-large': 'three_x_large', '3xlarge': 'three_x_large', '3x': 'three_x_large', '3-xl': 'three_x_large', '3xl': 'three_x_large',
          'xxxx-large': 'four_x_large', 'xxxxlarge': 'four_x_large', '4x-large': 'four_x_large', '4xlarge': 'four_x_large', '4x': 'four_x_large', '4-xl': 'four_x_large', '4xl': 'four_x_large',
          'xxxxx-large': 'five_x_large', 'xxxxxlarge': 'five_x_large', '5x-large': 'five_x_large', '5xlarge': 'five_x_large', '5x': 'five_x_large', '5-xl': 'five_x_large', '5xl': 'five_x_large',
          'xxxxxx-large': 'six_x_large', 'xxxxxxlarge': 'six_x_large', '6x-large': 'six_x_large', '6xlarge': 'six_x_large', '6x': 'six_x_large', '6-xl': 'six_x_large', '6xl': 'six_x_large'
        };
        const labels = JSON.parse(this.dataset.sizeDisplayLabels || '{}');
        return labels[aliases[key]] || raw;
      }

      updateLinks(size) {
        this.dataset.selectedSize = size || '';
        this.querySelectorAll('[data-linked-color-link]').forEach((link) => {
          const variants = JSON.parse(link.dataset.sizeVariants || '[]');
          const variant = size ? variants.find((item) => item.size === size) : null;
          const unavailable = Boolean(size && (!variant || !variant.available));
          const status = link.parentElement.querySelector('[data-linked-size-status]');
          const message = unavailable ? link.dataset.unavailableTemplate.replace('__SIZE__', this.displaySize(size)) : '';
          if (status) {
            status.textContent = message;
            status.hidden = !unavailable;
          }
          link.setAttribute('aria-label', message ? `${link.dataset.colorLabel}: ${message}` : link.dataset.colorLabel);
          link.closest('li')?.classList.toggle('awakndland-linked-color-swatches__item--unavailable', unavailable || link.dataset.productAvailable === 'false');
          if (size && !variant) {
            link.removeAttribute('href');
            link.setAttribute('role', 'link');
            link.setAttribute('tabindex', '0');
            link.setAttribute('aria-disabled', 'true');
          } else {
            const url = new URL(link.dataset.baseUrl, window.location.origin);
            if (variant) url.searchParams.set('variant', variant.id);
            link.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
            link.removeAttribute('role');
            link.removeAttribute('tabindex');
            link.removeAttribute('aria-disabled');
          }
        });
      }
    });
  }
